/**
 * 加载器ui
 * Bai.Zhiming
 * 2019-8-6
 */
angular.module("imLoadersModule", []).
directive("imLoaders", ['$templateRequest', 'globleParamsSet', '$compile', '$q', '$timeout', function($templateRequest, globleParamsSet, $compile, $q, $timeout) {
    return {
        restrict: 'AE',
        replace: false,
        scope: {
            loaders: '='
        },
        link(scope, $element, $attrs) {
            initStatus();
            initData();
            loadCss();
            /**
             * [loadCss description] 加载css
             * @return {[type]} [description]
             */
            function loadCss() {
                let link;
                let deffer = $q.defer();
                if ($(".loaders").length > 0) {
                    deffer.resolve();
                } else {
                    link = $("<link/>");
                    link.attr({
                        href: "./lib/loaders/loaders.css",
                        rel: "stylesheet",
                        class: "loaders"
                    });
                    $("head").append(link);
                    deffer.resolve();
                }
                scope.$on("$destroy", () => {
                    if (link) link.remove();
                });
                return deffer.promise;
            }
            /**
             * [initStatus description] 初始化数据
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {
                    loadersShow: false,
                    id: `loaders_${Math.round(Math.random() * 1e14)}`,
                    loaderType: $attrs['loaderType'] ? $attrs['loaderType'] : 'ball-pulse'
                    /**
                                           ball-grid-pulse
                                           ball-clip-rotate
                                           ball-clip-rotate-pulse
                                           square-spin
                                           ball-clip-rotate-multiple
                                           ball-pulse-rise
                                           ball-rotate
                                           cube-transition
                                           ball-zig-zag
                                           ball-zig-zag-deflect
                                           ball-triangle-path
                                           ball-scale
                                           line-scale
                                           line-scale-party
                                           ball-scale-multiple
                                           ball-pulse-sync
                                           ball-beat
                                           line-scale-pulse-out
                                           line-scale-pulse-out-rapid
                                           ball-scale-ripple
                                           ball-scale-ripple-multiple
                                           ball-spin-fade-loader
                                           line-spin-fade-loader
                                           triangle-skew-spin
                                           pacman
                                           semi-circle-spin
                                           ball-grid-beat
                                           ball-scale-random
                                       **/
                };
                loadCss().then(() => {
                    return getLoadersTemplate();
                }).then(() => {
                    watchLoaders();
                });
            }

            function getBoundingClientRect() {
                let deffer = $q.defer();
                $timeout(() => {
                    scope.status.loadersShow = true;
                    let boundingClientRect = $element[0].getBoundingClientRect();
                    scope.status.style = {
                        width: boundingClientRect.width + 'px',
                        height: boundingClientRect.height + 'px',
                        top: boundingClientRect.top + 'px',
                        left: boundingClientRect.left + 'px'
                    };
                    deffer.resolve();
                });
                return deffer.promise;
            }
            /**
             * [watchLoaders description] 开始监控loaders
             * @return {[type]} [description]
             */
            function watchLoaders() {
                scope.$watch('loaders', (newV, oldV) => {
                    if (!newV || !newV.then) return;
                    getBoundingClientRect().then(() => {
                        return newV
                    }).then(() => {
                        scope.status.loadersShow = false;
                    }, () => {
                        scope.status.loadersShow = false;
                    });
                });
            }
            /**
             * [forceClose description] 强行关闭
             * @return {[type]} [description]
             */
            scope.forceClose = function() {
                scope.status.loadersShow = false;
            };
            /**
             * [getLoadersTemplate description] 获取loaders的模板
             * @return {[type]} [description]
             */
            function getLoadersTemplate() {
                let deffer = $q.defer();
                $templateRequest("./IM/directive/loaders/loaders_tpl.html").then(template => {
                    let $template = $(template);
                    $template.attr('id', scope.status.id);
                    scope.status.loadersTemplate = $compile($template)(scope);
                    $("body").append(scope.status.loadersTemplate);
                    deffer.resolve();
                });
                scope.$on("$destroy", () => {
                    $(`#${scope.status.id}`).remove();
                })
                return deffer.promise;
            }
            /**
             * [initData description] 初始化状态
             * @return {[type]} [description]
             */
            function initData() {}
        }
    }
}]);